import { render, staticRenderFns } from "./detail-project.vue?vue&type=template&id=46cbec74&scoped=true&"
import script from "./detail-project.vue?vue&type=script&lang=js&"
export * from "./detail-project.vue?vue&type=script&lang=js&"
import style0 from "./detail-project.vue?vue&type=style&index=0&id=46cbec74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cbec74",
  null
  
)

export default component.exports